import TableColumn from '@/common/components/controls/table/TableColumn';
import UserViewService from '@/common/components/controls/table/TableUserSettings/UserViewService';
import OrganizationType from '@/common/models/memberships/OrganizationType.enum';

import ColumnsSerializer from './Serializers/ColumnsSeriliazer';
import SettingWrapper from './SettingWrapper';

export enum TableSettingKeys {
  TableSize = 'tableSize',
  PageSize = 'pageSize',
  SortBy = 'sortBy',
  SortAscending = 'sortAscending',
  Columns = 'columns',
  ShowComparison = 'showComparison',
  Filters = 'filters',
}

class TableSettings {
  private readonly tableId: string;

  public readonly tableSize: SettingWrapper<number>;

  public readonly pageSize: SettingWrapper<number>;

  public readonly sortBy: SettingWrapper<TableColumn>;

  public readonly sortAscending: SettingWrapper<boolean>;

  public readonly columns: SettingWrapper<Partial<TableColumn>[]>;

  public readonly showComparison: SettingWrapper<boolean>;

  public readonly filters: SettingWrapper<string>;

  public readonly userViewService: UserViewService;

  constructor(
    public orgType: OrganizationType,
    public id: string,
  ) {
    this.tableId = `tables.${orgType}.${id}`;
    this.tableSize = this.getTableSetting(TableSettingKeys.TableSize);
    this.pageSize = this.getTableSetting(TableSettingKeys.PageSize);
    this.sortBy = this.getTableSetting(TableSettingKeys.SortBy, (column: TableColumn) =>
      JSON.stringify({
        property: column.property,
        orderBy: column.orderBy,
      }),
    );
    this.sortAscending = this.getTableSetting(TableSettingKeys.SortAscending);
    this.columns = this.getTableSetting(TableSettingKeys.Columns, ColumnsSerializer.stringify, ColumnsSerializer.parse);
    this.showComparison = this.getTableSetting(TableSettingKeys.ShowComparison);
    this.filters = this.getTableSetting(TableSettingKeys.Filters);

    this.userViewService = new UserViewService(this.filters);
  }

  get userViews() {
    if (!this.userViewService) return [];
    return this.userViewService.views;
  }

  private getTableSetting<T>(
    key: TableSettingKeys,
    stringify: (val: T) => string = JSON.stringify,
    parse: (val: string) => T = JSON.parse,
  ): SettingWrapper<T> {
    return new SettingWrapper(`${this.tableId}.${key}`, stringify, parse);
  }
}

export default TableSettings;
